import { ReactNode, MouseEvent } from "react";
import { Link } from "react-router-dom";

interface Props {
  children: ReactNode;
  link: string;
  id?: string | undefined | null;
  auth?: boolean;
  setIsHovering?: () => void;
  onClick?: (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

const DropdownItem = ({ children, link, id, auth, setIsHovering, onClick }: Props) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    // Call both if provided
    if (setIsHovering) setIsHovering();
    if (onClick) onClick(e);
  };

  return (
    <>
      {auth ? (
        <a href={link} className="menu-item" onClick={handleClick}>
          {children}
        </a>
      ) : (
        <Link to={link} className="menu-item" onClick={handleClick}>
          {children}
        </Link>
      )}
    </>
  );
};

export default DropdownItem;
